import { createApp } from "vue";
import BulkApp from "../../vue/BulkApp.vue";

(function( $ ) {
	'use strict';

	 $(function() {

		var opengraphiqfontlist = [];
		var opengraphiqimageslist = [];

		var opengraphiqfontcounter = 0
		var opengraphiqimagecounter = 0

		var opengraphiqcounter = 0;

		var opengraphiqcurrentid;

		var ogtemp;

		var opengraphiqnonce;
		
		window.opengraphiqinitializeBulk = function(){

			window.opengraphiqidlist = [];
			window.opengraphiqidlist.push($("#og_post_id").val());

			opengraphiqsetvisibility();

			app.mount("#opengraphiqpostcanvas");

			if( $('#bulkgenerate').length ){
				$('#bulkgenerate').on('click', (event) => {
					opengraphiqcounter = 0;
					$('.og-ajax-result').remove();
					opengraphiqnonce = $( "#og_template_nonce" ).val();
					opengraphiqcurrentid = $("#og_post_id").val();
					ogtemp = $('#opengraphiq_setting_post_meta').val();
					$("#ogresponse").append('<div class="og-ajax-result working">' + adminJStranslations.working + '</div>');
					$("#bulkgenerate").hide();
					jQuery.ajax({
						method : "POST",
						url : opengraphiqAjax.ajaxurl,
						data : {action: "save_single_post_meta", og_template_nonce: opengraphiqnonce, id: opengraphiqcurrentid, opengraphiq_setting_post_meta: ogtemp,},
					}).done( function(msg) {
						opengraphiqfetchpostdata();
					});
				});
			};

			if( $('#bulksave').length ){
				$('#bulksave').on('click', (event) => {
					$('.og-ajax-result').remove();
					opengraphiqnonce = $( "#og_template_nonce" ).val();
					opengraphiqcurrentid = $("#og_post_id").val();
					ogtemp = $('#opengraphiq_setting_post_meta').val();
					$("#ogresponse").append('<div class="og-ajax-result working">' + adminJStranslations.working + '</div>');
					$("#bulksave").hide();
					jQuery.ajax({
						method : "POST",
						url : opengraphiqAjax.ajaxurl,
						data : {action: "save_single_post_meta", og_template_nonce: opengraphiqnonce, id: opengraphiqcurrentid, opengraphiq_setting_post_meta: ogtemp,},
					}).done( function(msg) {
						$(".og-ajax-result").removeClass("working").addClass("finished");
						$(".og-ajax-result").html(adminJStranslations.finished);
						$("#bulksave").show();
					});
				});
			};

			var oldHref = document.location.href;

			window.onload = function() {
				var bodyList = document.querySelector("body")

				if (window.location.href.indexOf("post-new.php") > -1) {

					var observer = new MutationObserver(function(mutations) {
						mutations.forEach(function(mutation) {
							if (oldHref != document.location.href) {
								oldHref = document.location.href;
								if (window.location.href.indexOf("post.php") > -1) {
									opengraphiqsetvisibility();
									$('.og-facebook-debugger').show();
									$('.og-twitter-validator').show();
									$('#bulkgenerate').show();
								}
							}
						});
					});

					var config = {
						childList: true,
						subtree: true
					};
					
					observer.observe(bodyList, config);

				}
				
			};

			$('#opengraphiq_setting_post_meta').on('change', function() {
				opengraphiqsetvisibility();
			});
		}

		window.opengraphiqfetchpostdata = function(){
			opengraphiqnonce = $( "#og_template_nonce" ).val();
			if (opengraphiqcounter < window.opengraphiqidlist.length){
				opengraphiqcurrentid = window.opengraphiqidlist[opengraphiqcounter];
				jQuery.ajax({
					method : "POST",
					url : opengraphiqAjax.ajaxurl,
					data : {action: "bulk_ajax", og_template_nonce: opengraphiqnonce, id: opengraphiqcurrentid},
				}).done( function(msg) {
					opengraphiqcounter += 1;

					if ( msg == '{}' ){
						$(".og-ajax-result").removeClass("working").addClass("cancelled");
						$(".og-ajax-result").html(adminJStranslations.skipped);
						$("#bulkgenerate").show();
						opengraphiqfetchpostdata();
					} else {
						var opengraphiqfontarray = [];
						var opengrpahiqimagearray = [];
						
						var domobject = JSON.parse(msg);

						for (const domobj of domobject){
							
							if (domobj["type"] == 'text' || domobj["type"] == 'dyntext') {
								if(!(opengraphiqfontlist.includes(domobj["fontfamily"]))) {
									opengraphiqfontlist.push(domobj["fontfamily"]);
									opengraphiqfontarray.push(domobj["fontfamily"]);
								}
							}
							
							if (domobj["type"] == 'image' || domobj["type"] == 'dynimage') {
								var urlimg;
								if (domobj["type"] == 'image'){
									urlimg = domobj["src"];
								} else {
									urlimg = domobj["backgroundimage"];
								}

								if (!opengraphiqimageslist.includes(urlimg)){
									opengraphiqimageslist.push(urlimg);
									opengrpahiqimagearray.push(urlimg);
								}
							}
						}

						if(opengraphiqfontarray.length > 0) opengraphiqfontcounter = 1;
						opengraphiqimagecounter = opengrpahiqimagearray.length;

						if(opengraphiqfontcounter == 0 && opengraphiqimagecounter == 0){
							opengrpahiqlaodingfinished();
						} else {
							if(opengraphiqfontcounter > 0){
								var urlfont = opengraphiqbulkaddfont(opengraphiqfontarray);
								var stylesheet = jQuery("<link>", {
									rel: "stylesheet",
									type: "text/css",
									href: urlfont,
								});
								stylesheet.load(opengrpahiqcheckfontloaded);
								stylesheet.appendTo("head");
							}
		
							if(opengraphiqimagecounter > 0){
								for (var i = 0; i < opengrpahiqimagearray.length; i++) {
									var tempImage = new Image();
									
									tempImage.addEventListener("load", opengrpahiqcheckimageloaded, true);
									tempImage.src = opengrpahiqimagearray[i];
								}
							}
						}

					}

					function opengrpahiqcheckfontloaded(){
						opengraphiqfontcounter--;
						if (opengraphiqfontcounter == 0 && opengraphiqimagecounter == 0){
							opengrpahiqlaodingfinished();
						}
					}

					function opengrpahiqcheckimageloaded(e){
						opengraphiqimagecounter--;
						if (opengraphiqfontcounter == 0 && opengraphiqimagecounter == 0){
							opengrpahiqlaodingfinished();
						}
					}

					function opengrpahiqlaodingfinished(){
						opegraphiqbulksetdata(domobject);
					}
				});
			} else {
				// Dodati kod koji treba da zavrsi celu pricu
				$(".bulk-finished-button").show();
			}
		}

		window.opengraphmakeshot = function(){
			
			html2canvas(document.querySelector("#wrapper-inner"), {
				onclone: function (clonedDoc) {
					clonedDoc.querySelector("#wrapper-inner").style.visibility = 'visible';
					clonedDoc.querySelector("#wrapper-inner").classList.add('og-generate');
				},
				windowWidth : 1216,
				windowHeight: 600,
				}).then(canvas => {
					jQuery.ajax({
						method : "POST",
						url : opengraphiqAjax.ajaxurl,
						data : {action: "bulk_ajax_create_photo", og_template_nonce: opengraphiqnonce, id: opengraphiqcurrentid, photodata: canvas.toDataURL('image/jpeg', 0.8)},
					}).done( function(msg) {
						var domobject = JSON.parse(msg);
						$(".og-ajax-result").removeClass('working').addClass('finished');
						$(".og-ajax-result").html( adminJStranslations.finished );
						$("#bulkgenerate").show();
						$("#og-post-image").show();
						$("#og-post-image img").attr("src", domobject.ogurl);
						$("#og-post-image-thickbox img").attr("src", domobject.ogurl);
						opengraphiqfetchpostdata();
					});
				});
		}

		window.opegraphiqbulksetdata = function(obj){
			app._component.data().store.domelements = obj;
		}

		window.opengraphiqsetvisibility = function(){
			$(".og-ajax-result").remove();
			if( $('#opengraphiq_setting_post_meta').val() == 0 ){
				if (window.location.href.indexOf("post-new.php") > -1) {
					$('#bulksave').hide();
				} else {
					$('#bulksave').show();
				}
				$('#ogtemplateno').show();
				$('#ogtemplateyes').hide();
			} else {
				$('#ogtemplateno').hide();
				$('#ogtemplateyes').show();
			}
		}

		window.opengraphiqbulkaddfont = function( fontarray ){
			var dynamlink = 'https://fonts.googleapis.com/css?family=';
			for (const fontfamily of fontarray){
				dynamlink += fontfamily + ':100,200,300,400,500,600,700,800,900,100italic,200italic,300italic,400italic,500italic,600italic,700italic,800italic,900italic|';
			}
			return dynamlink;
		}

		const app = createApp(BulkApp);
		
		opengraphiqinitializeBulk();
	});

})( jQuery );
